import { useState } from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { FoodsIcon } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { CREATE, DATA_LIST_VALUE_OVERRIDE, useFoodpilotContext } from "src/context/FoodpilotContext.tsx";
import { useQueryClient } from "react-query";
import { useSnackbar } from "src/utils/useSnackbar";
import { getAllDataListValueOverride } from "src/api/client-api/dataListValueOverride/useGetAllDataListValueOverride";
import { DataListValueOverrideModal } from "./DataListValueOverrideModal";
import { DataListsValuesOverridesContextProvider } from "./DataListsValuesOverridesContext";
import { DataListsValuesOverridesGrid } from "./DataListsValuesOverridesGrid";
import { useNavigateSettingsParent } from "../useNavigateSettingsParent";

export const DataListsValuesOverridesContent = () => {
    const { canUser } = useFoodpilotContext();

    const navigateSettingsParent = useNavigateSettingsParent();
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const snackbar = useSnackbar();

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    const handleOpenCreateModal = () => {
        setIsCreateModalOpen(true);
    };

    const handleCloseCreateModal = () => {
        setIsCreateModalOpen(false);
    };

    const handleCreateModalSuccess = () => {
        queryClient.invalidateQueries({ queryKey: [getAllDataListValueOverride] });
        snackbar.setSnackbarProps({
            message: "Item created successfully",
            type: "success",
        });
    };

    return (
        <Box sx={{ padding: "32px" }}>
            <Paper
                elevation={0}
                sx={{
                    border: "1px solid #E7E6E4",
                    borderRadius: "16px",
                    overflow: "hidden",
                    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.08)",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: "32px",
                        borderBottom: "1px solid #E7E6E4",
                        backgroundColor: "white",
                    }}
                >
                    <Box
                        sx={{
                            width: "28px",
                            height: "28px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={navigateSettingsParent}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                "& svg": {
                                    strokeWidth: "2px",
                                    stroke: "currentColor",
                                },
                            }}
                        >
                            <FoodsIcon icon="arrowLeftShort" size={6} />
                        </Box>
                    </Box>
                    <Box sx={{ marginLeft: "16px" }}>
                        <Typography variant="number-inter" sx={{ lineHeight: "1.6em", color: "#1E1E1E" }}>
                            {t("settings.data_lists_overrides", "Data lists values overrides")}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ padding: "32px", backgroundColor: "#FEFCFB" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                        <Box>
                            {/* <TextField
								placeholder={t("search", "Search...")}
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
								sx={{
									width: "300px",
									"& .MuiOutlinedInput-root": {
										borderRadius: "44px",
										backgroundColor: "white",
										height: "40px",
										border: "1px solid #E7E6E4",
										"& fieldset": { border: "none" },
										"&:hover fieldset": { border: "none" },
										"&.Mui-focused fieldset": { border: "none" },
									},
									"& .MuiInputBase-input": {
										fontSize: "0.875rem",
										fontWeight: 400,
										lineHeight: "1.6em",
										color: "#393A36",
									},
								}}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<SearchIcon sx={{ color: "#A3A2A0", fontSize: 20 }} />
										</InputAdornment>
									),
								}}
							/> */}
                        </Box>

                        {canUser(CREATE, DATA_LIST_VALUE_OVERRIDE) && (
                            <Button
                                variant="contained"
                                startIcon={<AddIcon sx={{ fontSize: 20 }} />}
                                onClick={handleOpenCreateModal}
                                sx={(theme) => ({
                                    background: `linear-gradient(180deg, ${theme.palette.primary[500]} 0%, ${theme.palette.primary[600]} 100%)`,
                                    borderRadius: "44px",
                                    px: 2.5,
                                    py: 1.25,
                                    height: "40px",
                                    textTransform: "none",
                                    fontSize: "0.875rem",
                                    fontWeight: 700,
                                    color: "white",
                                    boxShadow: "0px 4px 8px 0px rgba(42, 43, 39, 0.08)",
                                    "&:hover": {
                                        background: `linear-gradient(180deg, ${theme.palette.primary[600]} 0%, ${theme.palette.primary[700]} 100%)`,
                                        boxShadow: "0px 6px 12px 0px rgba(42, 43, 39, 0.12)",
                                    },
                                })}
                            >
                                {t("settings.data_lists_overrides.create", "Create data list values overrides")}
                            </Button>
                        )}
                    </Box>
                </Box>

                {/* Content area */}
                <Box sx={{ padding: "0px 32px 32px" }}>
                    <DataListsValuesOverridesGrid />
                </Box>
            </Paper>

            <DataListValueOverrideModal
                open={isCreateModalOpen}
                onClose={handleCloseCreateModal}
                onSuccess={handleCreateModalSuccess}
            />
        </Box>
    );
};

export const DataListsValuesOverrides = () => (
    <DataListsValuesOverridesContextProvider>
        <DataListsValuesOverridesContent />
    </DataListsValuesOverridesContextProvider>
);
